module.exports = __webpack_public_path__ + "img/3.d2c1d4de.png";